<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div style="display: flex">
        <div class="bg" :class="{bgEwm:cashingMethod === 1,bgInfo:cashingMethod === 2}"
             :style="{backgroundImage:'url(' + api.temp.FILE_PATH + cashingImg + ')'}">
          <div v-if="cashingMethod === 1" class="ewm">
            <img src="@/assets/img/ewm.jpg" alt="">
            <p>添加客服领取奖品吧!</p>
          </div>
          <div v-if="cashingMethod === 2" class="info">
            <div class="label" :style="{color: cashingFontColor}"><span>* </span>姓名：</div>
            <a-input type="text" value="请输入姓名" :disabled="true"
                     :style="{backgroundColor: cashingInputColor + '80',color: cashingFontColor}"></a-input>
            <div class="label" :style="{color: cashingFontColor}"><span>* </span>联系方式：</div>
            <a-input type="text" value="请输入手机号码" :disabled="true"
                     :style="{backgroundColor: cashingInputColor + '80',color: cashingFontColor}"></a-input>
            <div class="label" :style="{color: cashingFontColor}"><span>* </span>联系地址：</div>
            <a-textarea type="text" value="请输入联系地址" :disabled="true"
                        :style="{backgroundColor: cashingInputColor + '80',color: cashingFontColor}"></a-textarea>
            <div style="text-align: center">
              <button disabled>提交</button>
            </div>
          </div>
        </div>
        <div class="form">
          <div class="form_title">兑奖方式</div>
          <a-radio-group v-model="cashingMethod">
            <a-radio :value="1">
              添加员工兑奖
              <a-form-item label="兑奖员工"
                           :label-col="{ span: 4 }"
                           :wrapper-col="{ span: 8 }">
                <picker v-model="cashingUserId"
                        :text="cashingUserName"
                        ref="companyUserPicker"
                        title="选择相关人员"
                        @select="selectPicker"
                >
                  <template v-slot:childTable>
                    <employeeTable ref="employeeTable" @getTableData="getTableData"></employeeTable>
                  </template>
                </picker>
              </a-form-item>
              <div>建议关闭员工的添加验证，设置路径：企业微信APP设置>隐私</div>
            </a-radio>
            <a-radio :value="2">
              填写表单兑奖
              <div class="item"><span>*</span> 上传海报背景图
                <uploader :num="1" v-model="cashingImg" :accept="'image/*'"
                          :url="api.temp.UPLOAD_PATH"
                ></uploader>
                只能上传jpg、jpeg、png文件，建议尺寸：750px*1280px，不超过5M
              </div>
              <div class="item"><span>*</span> 字体颜色
                <colorPicker v-model="cashingFontColor" style="border: 1px solid #000"/>
              </div>
              <div class="item"><span>*</span> 输入框背景色
                <colorPicker v-model="cashingInputColor" style="border: 1px solid #000"/>
              </div>
            </a-radio>
          </a-radio-group>
        </div>
      </div>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="lastStep">上一步</a-button>
      <a-button type="primary" @click="submit">保存</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import Vue from 'vue'
import vcolorpicker from 'vcolorpicker'

Vue.use(vcolorpicker)
import {formMixin, fmt} from '@/utils/common/FormBase'
//厂商用户管理接口
import {dataApi} from "@/services/operate/marketingFission";

import employeeTable from './employeeTable'
import XEUtils from "xe-utils";

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.detail = entity.data
  this.cashingUserName = entity.data.cashingUserName
  this.userNames = entity.data.fissionUserName
  this.editable = entity.data.fissionUserId && entity.data.fissionUserId > 0
  this.cashingUserId = entity.data.cashingUserId
  this.cashingImg = entity.data.cashingImg || 'upload/20211221/299d6754622911ec86ea8f352e8f2c03.jpg'
  this.cashingFontColor = entity.data.cashingFontColor || '#fff'
  this.cashingInputColor = entity.data.cashingInputColor || '#FEB0AC'
  this.cashingMethod = entity.data.cashingMethod || 2
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  const vm = this
  let entities = this.detail
  entities.cashingMethod = vm.cashingMethod
  entities.cashingUserId = vm.cashingUserId
  entities.cashingImg = vm.cashingImg
  entities.cashingFontColor = vm.cashingFontColor
  entities.cashingInputColor = vm.cashingInputColor
  entities.addPrizeList = entities.prizeList
  entities.addLayoutList = entities.layoutList
  // if (!vm.userNames) {
  //   this.$message.error('请选择裂变员工')
  //   return false
  // } else {
  //   entities.userIds = vm.userIds ? vm.userIds.split(',') : []
  // }
  entities.isShow = 1
  await dataApi.saveFormDetail(entities).then(res => {
    if (res.code === 200) {
      this.$emit('saved')
    } else {
      this.$message.error(res.msg)
    }
  })
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}

/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {employeeTable},
  data() {
    return {
      cashingMethod: 1,
      cashingUserName: '',
      cashingUserId: '',
      detail: null,
      editable: false,
      cashingImg: 'upload/20211221/299d6754622911ec86ea8f352e8f2c03.jpg',
      cashingFontColor: '#fff',
      cashingInputColor: '#FEB0AC',
      userIds: '',
      userNames: ''
    }
  },
  mounted() {

  },
  methods: {
    loadEntity,
    loadBaseData,
    submit,
    lastStep() {
      this.$emit('lastStep')
    },
    getTableData(res, type) {
      switch (type) {
        case 'employeeTable': {
          //给选择窗组件赋值
          this.cashingUserName = res.userName;

          //给表单选项赋值
          this.cashingUserId = res.userId
        }
          break;
        case 'userSelect': {
          const nameArr = this.userNames ? this.userNames.split(',') : []
          const idArr = this.userIds ? this.userIds.split(',') : []
          this.userNames = XEUtils.union(nameArr, res.map(item => {
            return item.userName
          })).join(',')
          this.userIds = XEUtils.union(idArr, res.map(item => {
            return item.userId
          })).join(',')
        }
          break;
        default:
          break
      }
    },
    deleteTag(list) {
      this.userNames = list.map(item => {
        return item.text
      }).join(',')
      this.userIds = list.map(item => {
        return item.id
      }).join(',')
    }
  }
};
</script>
<style lang="less" scoped>
.bg {
  position: relative;
  width: 375px;
  height: 667px;
  border: 1px solid #000;
  background-repeat: no-repeat;
  background-size: cover;

  &.bgInfo {
    background-image: url("../../../../../assets/img/form_bg.png");
    background-size: cover;
  }

  &.bgEwm {
    background-image: url("../../../../../assets/img/ewm_bg.png");
    background-size: cover;
  }

  .ewm {
    text-align: center;
    color: #fff;

    img {
      display: block;
      width: 93px;
      height: 93px;
      margin: 500px auto 16px;
    }

  }

  .info {
    width: 65%;
    margin: 225px auto 0;
    color: #fff;

    .label {
      margin: 16px 0 7px;
    }

    input, textarea {
      border: none;
      outline: none;
      height: 33px;
      line-height: 33px;
      //background: RGBA(249, 160, 153, 0.8);
      border-radius: 2px;
    }

    textarea {
      height: auto;
    }

    button {
      width: 127px;
      height: 46px;
      margin-top: 30%;
      background-image: url("../../../../../assets/img/gold_button.png");
      background-size: cover;
      border: none;
      outline: none;
      border-radius: 23px;
    }
  }
}

.form {
  flex: 1;
  margin-left: 24px;

  .item {
    color: #333;
    margin-top: 12px;

    span {
      color: #D90B18;
    }
  }

  .keys {
    display: flex;
    margin: 16px 0;

    li {
      margin-bottom: 12px;
    }
  }
}

/deep/ .ant-radio-wrapper {
  display: block;
}

/deep/ .m-colorPicker {
  top: 3px
}
</style>
